import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import CrossIcon from "sweet-web/components/icons/CrossIcon";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import BookPricing from "./BookPricing";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: box;
  background-color: ${colors.white};
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  width: 100%;
  padding: 10px 0;
`;

const ContentHeader = styled.div`
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  z-index: 60;
  border-bottom: 1px solid ${colors.lightGray};
`;

const ContentHeaderTitle = styled.h1`
  font-size: 17px;
  font-weight: 700;
  color: ${colors.nearBlack};
`;

const ExitButton = styled(NavLink)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 60px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  outline: none;
  background-color: ${colors.white};
  border: none;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const MobileBook: React.FC<Props> = props => {
  const { venue } = props;
  const { venueId } = props.match.params as { venueId: string };

  return (
    <Wrapper>
      <ContentHeader>
        <ContentHeaderTitle>{venue.name}</ContentHeaderTitle>
        <ExitButton to={`/v/${venueId}`}>
          <CrossIcon size={24} color={colors.gray} style={{ marginTop: 3 }} />
        </ExitButton>
      </ContentHeader>
      <Body>
        <BookPricing preview={false} venueId={venueId} />
      </Body>
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { venueId } = ownProps.match.params as { venueId: string };

  return {
    venue: selectors.getVenue(venueId)(state)
  };
};
const mapDispatch = (dispatch: Dispatch) => bindActionCreators({}, dispatch);
const connector = connect(mapState, mapDispatch);

export default withRouter(connector(MobileBook));
